import React from 'react';
import './BottomNav.css';

const navItems = [
  { label: 'Home', screen: 'Home' },
  { label: 'Pass', screen: 'Ticket' },
  { label: 'Alerts', screen: 'Notifications' },
  { label: 'Details', screen: 'EventDetails' },
];

function BottomNav({ activeScreen = 'Home', onNavigate = () => {} }) {
  return (
    <nav className="bottom-nav" aria-label="Main navigation">
      {navItems.map((item) => (
        <button
          className={activeScreen === item.screen ? 'active' : ''}
          key={item.label}
          onClick={() => onNavigate(item.screen)}
          type="button"
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}

export default BottomNav;
